export const MUNICIPALITIES_REQUEST = "MUNICIPALITIES_REQUEST";
export const MUNICIPALITIES_SUCCESS = "MUNICIPALITIES_SUCCESS";
export const MUNICIPALITIES_FAIL = "MUNICIPALITIES_FAIL";
